import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    color?: string;
    width?: number;
    height?: number;
};

export const ChevronLeftIcon = (props: Props) => {
    const { color = 'currentColor', width = 16, height = 26, ...rest } = props;
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 16 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path d="M12.09 26L15.1883 23.2122L5.61889 13.3972L15.1883 2.80222L12.09 0L0 13.3828L12.09 26Z" fill={color} />
        </svg>
    );
};
